import { Component, Inject, type OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { DealerDTO } from '../../../services/dealers.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-app-live-chat-dialog',
  standalone: true,
  templateUrl: './live-chat-dialog.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class LiveChatDialogComponent implements OnInit {
  id: number

  constructor (
    private readonly dialogRef: MatDialogRef<LiveChatDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DealerDTO
  ) {}

  ngOnInit (): void {
    this.id = this.data.liveChatGroupId
  }

  save (): void {
    this.dialogRef.close(this.data)
  }
}
